export default __webpack_public_path__ + "static/media/cancel.4e3f631b.svg";